import { useChat } from '../contexts/ChatContext'

export default function ModeToggle() {
  const { currentMode, setCurrentMode, isStreaming } = useChat()

  const modeDescriptions = {
    conversation: 'الوضع الحالي: توليد إجابات كاملة مع المراجع',
    retrieval: 'الوضع الحالي: استرجاع المواد فقط بدون توليد إجابة'
  }

  return (
    <div className="border-b border-border/50 bg-background/50">
      {/* Compact Mode Toggle */}
      <div className="flex items-center justify-center gap-2 px-4 py-2">
        {/* Segmented Control */}
        <div className="relative inline-flex bg-muted/50 border border-border rounded-lg p-0.5">
          {/* Sliding indicator */}
          <div
            className={`
              absolute top-0.5 h-[calc(100%-4px)] rounded-md bg-primary shadow-sm
              transition-all duration-300 ease-out
              ${currentMode === 'conversation'
                ? 'right-0.5 w-[calc(50%-2px)]'
                : 'left-0.5 w-[calc(50%-2px)]'
              }
            `}
          />

          {/* Buttons */}
          <button
            onClick={() => !isStreaming && setCurrentMode('conversation')}
            disabled={isStreaming}
            className={`
              relative z-10 px-3 py-1 text-xs font-medium transition-colors duration-300 rounded-md flex items-center gap-1.5
              ${currentMode === 'conversation'
                ? 'text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground'
              }
              ${isStreaming ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}
            `}
            title="توليد إجابات كاملة مع المراجع"
          >
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
            <span>محادثة</span>
          </button>

          <button
            onClick={() => !isStreaming && setCurrentMode('retrieval')}
            disabled={isStreaming}
            className={`
              relative z-10 px-3 py-1 text-xs font-medium transition-colors duration-300 rounded-md flex items-center gap-1.5
              ${currentMode === 'retrieval'
                ? 'text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground'
              }
              ${isStreaming ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}
            `}
            title="استرجاع المواد فقط بدون توليد إجابة"
          >
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <span>استرجاع</span>
          </button>
        </div>
      </div>
    </div>
  )
}
